var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryBreakfast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_465_8847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.508 41.8764C149.508 32.2414 134.456 24.4305 115.888 24.4305C105.036 24.4305 73.445 24.4305 62.5935 24.4305C44.0259 24.4305 28.9738 32.2414 28.9738 41.8764C28.9738 48.745 36.6235 54.6858 47.7426 57.5314C50.5862 58.2591 52.9865 60.1379 54.4762 62.6667C59.3362 70.9161 71.5494 76.7679 85.8483 76.7679C99.155 76.7679 110.655 71.7 116.104 64.3482C118.371 61.2888 121.698 59.1823 125.462 58.6032C139.365 56.4641 149.508 49.7852 149.508 41.8764Z",
    fill: "url(#paint0_radial_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.041 24.5076C118.003 24.4576 116.951 24.4305 115.888 24.4305C105.987 24.4305 78.8244 24.4305 65.8982 24.4305C61.7664 28.9417 59.3194 34.5423 59.3194 40.6097C59.3194 42.2897 60.1597 43.7802 61.6473 45.0823L92.8517 76.2867C103.108 74.8617 111.638 70.3729 116.103 64.3485C118.371 61.2891 121.697 59.1826 125.461 58.6035C133.822 57.317 140.818 54.3879 145.071 50.5382L119.041 24.5076Z",
    fill: "url(#paint1_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.515 40.6097C125.515 55.5409 59.3197 55.5409 59.3197 40.6097C59.3197 25.6785 74.1379 13.5744 92.4174 13.5744C110.697 13.5744 125.515 25.6785 125.515 40.6097Z",
    fill: "url(#paint2_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.338 36.3009C117.707 36.3009 118.817 35.1909 118.817 33.8218C118.817 32.4526 117.707 31.3427 116.338 31.3427C114.968 31.3427 113.859 32.4526 113.859 33.8218C113.859 35.1909 114.968 36.3009 116.338 36.3009Z",
    fill: "url(#paint3_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.735 42.1903C112.816 42.1903 113.692 41.314 113.692 40.233C113.692 39.152 112.816 38.2756 111.735 38.2756C110.654 38.2756 109.777 39.152 109.777 40.233C109.777 41.314 110.654 42.1903 111.735 42.1903Z",
    fill: "url(#paint4_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.266 43.0553C120.918 43.0553 121.446 42.527 121.446 41.8753C121.446 41.2236 120.918 40.6953 120.266 40.6953C119.614 40.6953 119.086 41.2236 119.086 41.8753C119.086 42.527 119.614 43.0553 120.266 43.0553Z",
    fill: "url(#paint5_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0285 20.0121C100.986 25.6547 95.9568 34.1215 86.795 38.9235C77.6332 43.7256 67.8091 43.0438 64.8518 37.4012C61.8944 31.7585 66.9235 23.2918 76.0853 18.4897C85.2471 13.6876 95.0709 14.3694 98.0285 20.0121Z",
    fill: "url(#paint6_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.508 84.98C149.508 71.1765 127.529 57.6671 100.417 57.6671C87.2169 57.6671 48.6269 57.6671 35.3208 57.6671C15.5419 57.6671 -0.492188 65.9276 -0.492188 76.1173C-0.492188 79.1197 0.899871 81.9541 3.36958 84.4591C8.3887 89.5503 10.5622 96.6203 9.32075 103.468C9.06281 104.891 8.92928 106.346 8.92928 107.828C8.92928 124.058 24.9634 137.215 44.7422 137.215C51.639 137.215 58.0799 135.615 63.5443 132.843C69.1322 130.008 75.5978 129.21 81.8237 130.374C84.7722 130.925 87.8413 131.216 90.9937 131.216C109.01 131.216 124.319 121.715 129.878 108.491C130.959 105.919 132.948 103.789 135.518 102.45C144.173 97.9444 149.508 91.78 149.508 84.98Z",
    fill: "url(#paint7_radial_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.742 99.2347L106.949 65.4423C104.03 62.3821 100.474 59.7479 96.4473 57.6671C85.84 57.6671 67.2641 57.6671 52.5626 57.6671C41.0494 63.6168 33.4035 74.1082 33.4035 86.0597C33.4035 88.1632 34.4644 90.0271 36.34 91.6535L74.5956 129.909C76.9982 129.772 79.4285 129.926 81.8238 130.374C84.7723 130.925 87.8415 131.216 90.9938 131.216C109.01 131.216 124.319 121.715 129.878 108.491C130.959 105.919 132.948 103.789 135.519 102.45C137.429 101.456 139.177 100.38 140.742 99.2347Z",
    fill: "url(#paint8_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.612 86.0597C115.612 104.603 33.4035 104.603 33.4035 86.0597C33.4035 67.5164 51.8064 52.4844 74.5076 52.4844C97.2088 52.4844 115.612 67.5167 115.612 86.0597Z",
    fill: "url(#paint9_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M67.5702 88.8076C68.9394 88.8076 70.0493 87.6977 70.0493 86.3285C70.0493 84.9593 68.9394 83.8494 67.5702 83.8494C66.201 83.8494 65.0911 84.9593 65.0911 86.3285C65.0911 87.6977 66.201 88.8076 67.5702 88.8076Z",
    fill: "url(#paint10_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.9671 94.697C64.0481 94.697 64.9245 93.8207 64.9245 92.7396C64.9245 91.6586 64.0481 90.7823 62.9671 90.7823C61.8861 90.7823 61.0098 91.6586 61.0098 92.7396C61.0098 93.8207 61.8861 94.697 62.9671 94.697Z",
    fill: "url(#paint11_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.4981 95.562C72.1498 95.562 72.6781 95.0337 72.6781 94.382C72.6781 93.7303 72.1498 93.202 71.4981 93.202C70.8464 93.202 70.3181 93.7303 70.3181 94.382C70.3181 95.0337 70.8464 95.562 71.4981 95.562Z",
    fill: "url(#paint12_linear_465_8847)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.6786 90.0287C81.6904 90.0287 82.5106 89.2085 82.5106 88.1967C82.5106 87.1849 81.6904 86.3646 80.6786 86.3646C79.6667 86.3646 78.8465 87.1849 78.8465 88.1967C78.8465 89.2085 79.6667 90.0287 80.6786 90.0287Z",
    fill: "url(#paint13_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.8803 90.2664C75.679 90.2664 76.3265 89.619 76.3265 88.8203C76.3265 88.0216 75.679 87.3741 74.8803 87.3741C74.0816 87.3741 73.4341 88.0216 73.4341 88.8203C73.4341 89.619 74.0816 90.2664 74.8803 90.2664Z",
    fill: "url(#paint14_linear_465_8847)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.1788 95.1999C78.6604 95.1999 79.0508 94.8095 79.0508 94.3279C79.0508 93.8462 78.6604 93.4558 78.1788 93.4558C77.6971 93.4558 77.3067 93.8462 77.3067 94.3279C77.3067 94.8095 77.6971 95.1999 78.1788 95.1999Z",
    fill: "url(#paint15_linear_465_8847)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80.0983 63.595C83.9274 70.9006 78.953 81.0573 68.9877 86.2803C59.0224 91.5032 47.8398 89.8152 44.0107 82.5097C40.1815 75.2041 45.156 65.0473 55.1213 59.8244C65.0865 54.6014 76.2692 56.2894 80.0983 63.595Z",
    fill: "url(#paint16_linear_465_8847)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_465_8847",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1032 36.9506) scale(69.211 46.8804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5047,
    stopColor: "#F7F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    stopColor: "#F5ECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#F0DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8847",
    x1: 111.631,
    y1: 67.9799,
    x2: 81.0135,
    y2: -3.07564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8847",
    x1: 88.0341,
    y1: 27.8068,
    x2: 102.152,
    y2: 63.6891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8847",
    x1: 118.557,
    y1: 37.0053,
    x2: 112.223,
    y2: 27.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8847",
    x1: 113.524,
    y1: 42.751,
    x2: 108.523,
    y2: 34.9469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_8847",
    x1: 121.421,
    y1: 43.3964,
    x2: 118.406,
    y2: 38.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8847",
    x1: 82.7224,
    y1: 30.6007,
    x2: 67.0467,
    y2: 0.717453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_465_8847",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4267 57.788) scale(81.4025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5047,
    stopColor: "#F7F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    stopColor: "#F5ECFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#F0DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8847",
    x1: 93.4926,
    y1: 115.573,
    x2: 69.2962,
    y2: 30.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8847",
    x1: 68.055,
    y1: 60.2929,
    x2: 78.9685,
    y2: 101.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8847",
    x1: 69.7708,
    y1: 89.5442,
    x2: 63.4361,
    y2: 79.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8847",
    x1: 64.7371,
    y1: 95.2896,
    x2: 59.7363,
    y2: 87.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8847",
    x1: 72.6342,
    y1: 95.9351,
    x2: 69.6192,
    y2: 91.2302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8847",
    x1: 80.0437,
    y1: 90.901,
    x2: 82.3656,
    y2: 82.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8847",
    x1: 74.4007,
    y1: 90.9598,
    x2: 76.2341,
    y2: 84.3623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8847",
    x1: 77.9356,
    y1: 95.6256,
    x2: 79.0406,
    y2: 91.6481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8847",
    x1: 63.8962,
    y1: 76.6114,
    x2: 43.594,
    y2: 37.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_465_8847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(-0.492188 0.39502)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryBreakfast);
export default __webpack_public_path__ + "static/media/icon-category-breakfast.1be1ff4f.svg";
export { ForwardRef as ReactComponent };